import { ProgressItem } from '../../../../../global/components/navigation/generic-stepper';
import { AnnualEnrollmentRoutes } from '../../../../annual-enrollment/constants/annual-enrollment-routes';
import { NewHireEnrollmentRoutes } from '../../../../arc/features/new-hire-enrollment/models/new-hire-routes';
import { BenefitEnrollmentStep } from '../../../../arc/features/new-hire-enrollment/models/pension-enrollment-models';
import { AccountInfoRoutes } from '../../../constants/routes';
import { MyCPGMidYearProps } from '../models/mycpg-midyear-epi-props';

export function getMyCPGMidyearEnrollmentSteps() {
	return [BenefitEnrollmentStep.PERSONAL_INFORMATION, BenefitEnrollmentStep.RELATIONSHIP, BenefitEnrollmentStep.COVERAGE, BenefitEnrollmentStep.REVIEW];
}



export function getMyCPGMidyearEnrollmentStepItems(settings: MyCPGMidYearProps) {
	const progressItem: ProgressItem[] = [];
	progressItem.push(
		{
			stepName: settings?.personalInformationStepBarName,
			linkUrl: AccountInfoRoutes.PersonalInfoSegment,
			step: BenefitEnrollmentStep.PERSONAL_INFORMATION,
		},
	);
	progressItem.push(
		{
			stepName: settings?.relationshipStepBarName,
			linkUrl: AccountInfoRoutes.RelationshipsSegment,
			step: BenefitEnrollmentStep.RELATIONSHIP,
		},
	);

	progressItem.push(
		{
			stepName: settings?.coverageStepBarName,
			linkUrl: NewHireEnrollmentRoutes.Coverage,
			step: BenefitEnrollmentStep.COVERAGE,
		},
	);
	progressItem.push(
		{
			stepName: settings?.reviewStepBarName,
			linkUrl: NewHireEnrollmentRoutes.Coverage,
			step: BenefitEnrollmentStep.REVIEW,
		},
	);

	return progressItem;
}


export function shouldShowMidYearHeader(history: any) {
	return history?.location?.pathname?.includes(AccountInfoRoutes.Midyear) && !history?.location?.pathname?.includes(AnnualEnrollmentRoutes.Confirmation);
}